







import Vue from 'vue';
import CustomType from '../src/types/vue';

export interface ComponentApp extends Vue {
  translateMessage: (str: string) => string
}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'Index',
  data() {
    return {}
  },
  computed: {
    locale: function(){
      return this.$store.state.locale;
    }
  },
  methods: {
    translateMessage: function (cle) {
        if (Number.isInteger(parseInt(cle)))
            return cle

        if (cle === "" || cle === undefined || cle === null)
            return "";

        return this.translate(this.$store.state.locale, cle);
    },
  },
  watch: {
    locale: function () {
      document.title = this.translateMessage('site-title');
    },
  },
  mounted: function() {
    if(this.$store.state.locales.indexOf(this.$route.params.locale) != -1){
      this.$store.state.locale = this.$route.params.locale;     
    }else{
      this.$store.state.locale = "fr";
      this.$router.push('/');
    }
  }
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Index.vue